export const OPCIONES_ESTATUS_VENDEDORA = [
  { label: 'Disponible', value: 'Disponible', color: '#4FC3F7' },
  { label: 'En llamada', value: 'En llamada', color: '#26C6DA' },
  { label: 'En informes', value: 'En informes', color: '#7E57C2' },
  { label: 'Ocupada', value: 'Ocupada', color: '#FFB74D' },
  { label: 'Comiendo', value: 'Comiendo', color: '#81C784' },
];

export function colorEstatusVendedora(estatus) {
  const op = OPCIONES_ESTATUS_VENDEDORA.find((o) => o.value === estatus);
  return op ? op.color : '#4FC3F7';
}

export function textoEstatusVendedora(estatus) {
  return ['Ocupada', 'Comiendo'].includes(estatus) ? '#1a237e' : '#ffffff';
}

export function iconoEstatusVendedora(estatus) {
  const map = {
    Disponible: 'mdi-check-circle-outline',
    'En llamada': 'mdi-phone-in-talk',
    'En informes': 'mdi-file-document-outline',
    Ocupada: 'mdi-account-clock',
    Comiendo: 'mdi-food-fork-drink',
  };
  return map[estatus] || 'mdi-circle';
}

export function esVendedoraRanking(idpuesto) {
  return [18, 73].includes(Number(idpuesto));
}

export function estatusRecepcionDeMap(map, id_usuario) {
  if (id_usuario == null) return 'Disponible';
  const id = Number(id_usuario);
  if (!map) return 'Disponible';
  return map[id] || map[String(id)] || 'Disponible';
}
